import React from 'react';
import { Trophy, LayoutList, Award } from 'lucide-react';
import { METRICS, getUserColor } from './constants';
import Avatar from '../Avatar';

const Scoreboard = ({ scoreboardMode, setScoreboardMode, loading, allUsers, allUserIds, userStats, metric }) => {
  return (
    <div className="bg-ink-card3 rounded-2xl border border-white/10 p-5 shadow-inner">
      <div className="flex items-center justify-between mb-4">
        <div className="flex items-center gap-2">
          <Trophy size={18} className="text-amber-400" />
          <h3 className="text-sm font-mono font-medium text-ink-fg/70 uppercase tracking-wider">Household Scoreboard</h3>
        </div>
        <div className="flex bg-ink-card2 rounded-lg border border-white/10 p-0.5">
          <button
            onClick={() => setScoreboardMode('ranked')}
            className={`p-1.5 rounded-md transition-all ${scoreboardMode === 'ranked' ? 'bg-mint text-ink-shell shadow-sm' : 'text-ink-fg/40 hover:text-mint'}`}
            title="Ranked List"
          >
            <LayoutList size={14} />
          </button>
          <button
            onClick={() => setScoreboardMode('leaders')}
            className={`p-1.5 rounded-md transition-all ${scoreboardMode === 'leaders' ? 'bg-mint text-ink-shell shadow-sm' : 'text-ink-fg/40 hover:text-mint'}`}
            title="Metric Leaders"
          >
            <Award size={14} />
          </button>
        </div>
      </div>

      {loading ? (
        <div className="h-24 rounded-xl skeleton-shimmer" />
      ) : allUsers.length === 0 ? (
        <div className="text-center py-4 text-xs text-ink-fg/40 italic">No rankings available.</div>
      ) : scoreboardMode === 'ranked' ? (
        <div className="space-y-2">
          {[...userStats].sort((a, b) => b[metric] - a[metric]).map((stat, idx) => (
            <div key={stat.id} className="flex items-center justify-between bg-ink-card px-4 py-2.5 rounded-xl border border-white/10 shadow-sm">
              <div className="flex items-center gap-3">
                <span className={`w-5 h-5 flex items-center justify-center rounded-full text-[10px] font-bold ${idx === 0 ? 'bg-amber-400/20 text-amber-300' : 'bg-ink-card2 text-ink-fg/50'}`}>
                  {idx + 1}
                </span>
                <Avatar
                  user={stat}
                  color={getUserColor(stat, allUserIds)}
                  size="w-6 h-6"
                  textSize="text-[8px]"
                  ring="border border-white/15"
                />
                <span className="text-sm font-semibold text-ink-fg/90">{stat.name}</span>
              </div>
              <span className="text-sm font-bold font-mono text-mint">
                {stat[metric]}{METRICS.find(m => m.key === metric)?.unit}
              </span>
            </div>
          ))}
        </div>
      ) : (
        <div className="grid grid-cols-2 gap-3">
          {METRICS.map(m => {
            const leader = [...userStats].sort((a, b) => b[m.key] - a[m.key])[0];
            const Icon = m.icon;
            return (
              <div key={m.key} className="bg-ink-card p-3 rounded-xl border border-white/10 shadow-sm flex flex-col gap-1">
                <div className="flex items-center gap-1.5 text-[10px] font-mono font-medium text-ink-fg/40 uppercase truncate">
                  <Icon size={10} /> {m.label}
                </div>
                <div className="flex items-center gap-2 mt-1">
                  <Avatar
                    user={leader}
                    color={getUserColor(leader, allUserIds)}
                    size="w-8 h-8"
                    textSize="text-[10px]"
                    ring="border-2 border-white/15"
                  />
                  <div className="min-w-0">
                    <p className="text-xs font-bold text-ink-fg/90 truncate">{leader.name}</p>
                    <p className="text-[10px] font-bold font-mono text-mint">{leader[m.key]}{m.unit}</p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default Scoreboard;
